import {  replace} from 'lodash';


export function navigatToDriverDetail(e, user, urlPath, currentGroupID, navigate, dispatch) {
	e.preventDefault();

	const path = replace(urlPath, ':id', user?.userID).replace(':groupid', currentGroupID);
	navigate(path);
}

export function navigatToDriverIncidentDetail(user, urlPath, currentGroupID, incidentName, navigate, dispatch) {

	const path = replace(urlPath, ':id', user?.userID).replace(':groupid', currentGroupID).replace(':name', incidentName)
	navigate(path);
}
